<template>
  <v-navigation-drawer
    :value="value"
    @input="$emit('input', $event)"
    :permanent="isDesktop"
    :absolute="!isDesktop"
    :temporary="!isDesktop"
    width="300"
    class="elevation-1"
    color="white"
  >
    <div class="pa-4">
      <div class="text-overline mb-2 primary--text font-weight-black">
        Explorar {{ listaModo }}
      </div>

      <v-divider class="mb-4" />

      <template v-if="listaModo === 'armarios'">
        <v-alert v-if="errorCarga" dense text type="warning" class="caption">
          No se han podido cargar los armarios.
        </v-alert>
        <v-alert
          v-else-if="!treeData || treeData.length === 0"
          dense
          text
          type="info"
          class="caption"
        >
          Todavía no hay armarios.
        </v-alert>

        <div class="sidebar-scroll">
          <ArmariosLista
            v-for="armario in treeData"
            :key="armario.id"
            :node="armario"
            :selectedNode="selectedNode"
            @select="$emit('select-node', $event)"
            @toggle="$emit('toggle-node', $event)"
          />
        </div>
      </template>

      <template v-else>
        <div class="sidebar-scroll text-center">
          <PlanosLista
            :modo="1"
            :planosData="planosData"
            :planoSeleccionado="selectedPlano"
            @select="$emit('select-plano', $event)"
            @plano-creado="$emit('plano-creado')"
          />
        </div>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import ArmariosLista from "@/components/utils/ArmariosLista.vue";
import PlanosLista from "@/components/utils/PlanosLista.vue";

export default {
  name: "ArmariosDrawer",
  components: { ArmariosLista, PlanosLista },
  props: {
    value: { type: Boolean, default: false }, // v-model
    isDesktop: { type: Boolean, default: true },
    listaModo: { type: String, required: true },
    treeData: { type: Array, default: () => [] },
    errorCarga: { type: String, default: "" },
    selectedNode: { type: Object, default: null },
    planosData: { type: Array, default: () => [] },
    selectedPlano: { type: [Object, Number, String], default: null },
  },
};
</script>

<style scoped>
.sidebar-scroll {
  height: calc(100vh - 150px);
  overflow-y: auto;
}
.sidebar-scroll::-webkit-scrollbar {
  width: 4px;
}
.sidebar-scroll::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 10px;
}
</style>